var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAdmin)?_c('home-admin'):(_vm.isUser)?_c('home-user'):_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{staticClass:"mt-12",attrs:{"indeterminate":"","color":"primary","size":"150"}},[_vm._v("Laden...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }